import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

export default {
    namespaced: true,

    state: {
        faqId: '',
        deleteModal: false,
        question: '',
        answer: '',
        order: 0,
        postData: [],
        route: '',
    },

    getters: {
        postData(state) {
            return {
                question: state.question,
                answer: state.answer,
                order: parseInt(state.order),
            };
        },

        route(state) {
            if (state.faqId) {
                return '/api/faq/edit/' + state.faqId;
            } else {
                return '/api/faq/create';
            }
        }
    },

    mutations: {
        setFaqId(state, value) {
            state.faqId = value;
        },

        setQuestion(state, value) {
            state.question = value;
        },

        setAnswer(state, value) {
            state.answer = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setFaqId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            if(state.faqId) {
                getEditorData(getters.route).then((response) => {
                    const faq = response.data.data.faq;
                    commit('setQuestion', faq.question);
                    commit('setAnswer', faq.answer);
                    commit('setOrder', faq.order);
                    commit('overlay/toggle', false, { root: true });
                });
            } else {
                commit('setQuestion', '');
                commit('setAnswer', '');
                commit('setOrder', 0);
                commit('overlay/toggle', false, { root: true });
            }
        },

        saveData({ getters, commit, dispatch }) {
            saveEditorData('faq', getters.route, getters.postData)
                .then((faqId) => {
                    if (router.currentRoute.name === 'FaqEdit') {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                commit('overlay/toggle', false, { root: true });
                            });
                    } else {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                router.push('/faq/edit/' + faqId);
                            });
                    }
                })
                .catch(() => {});
        },

        destroyData({ state, dispatch }) {
            destroyEditorData('/api/faq/delete/' + state.faqId)
                .then(() => {
                    dispatch('sidebar/getSidebar', '', { root: true });
                })
                .catch(() => {});
        },
    },
};
